/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { MyAsiCustomersSystemInfoControllerService } from './services/my-asi-customers-system-info-controller.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    MyAsiCustomersSystemInfoControllerService,
    ApiConfiguration
  ],
})
export class CustomersSysteminfoModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<CustomersSysteminfoModule> {
    return {
      ngModule: CustomersSysteminfoModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: CustomersSysteminfoModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('CustomersSysteminfoModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
